const isRequestIdleCallbackSupported =
  typeof requestIdleCallback === 'function';

export const rIC = isRequestIdleCallbackSupported
  ? requestIdleCallback
  : setTimeout;
export const cIC = isRequestIdleCallbackSupported
  ? cancelIdleCallback
  : clearTimeout;
